import type { Prototype } from "../prototype-types";

export const chanyeeKimPrototypes: Prototype[] = [
  {
    id: "dollar-off-free-shipping-promo",
    name: "Dollar Off + Free Shipping Promo",
    path: "/kim/dollar-off-free-shipping-promo",
    description:
      "Brand portal shop-wide promo creation matching the shipped overlapping-promo warning: info banner under the selected discount type when the targeted customer segment already has a same-type promotion on the selected dates.",
    owner: "Chanyee Kim",
    createdAt: "2026-07-17",
    lastUpdated: "2026-08-13",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ef3e2a7b2a8d67b68b941d416e18d0b3db6096eb499dd3231f74a090647b2f3e.png",
    creationTool: "cursor",
  },
  {
    id: "insider-source",
    name: "Insider Source",
    path: "/kim/insider-source",
    description:
      "The Faire Source shop page rebranded for Insider: Insider banner, About Insider tab, enrolled savings banner, Insider Cart, and Insider tile badges. Toggle between unenrolled and enrolled-active states.",
    owner: "Chanyee Kim",
    createdAt: "2026-06-02",
    lastUpdated: "2026-06-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/cfdbb9297a8c4bdd2e9f992d4745cf4f20cabaa50c117c4d3d79a5aaaad340fd.png",
    creationTool: "cursor",
  },
  {
    id: "kim-customizable-segment-promo-duration",
    name: "Customizable Segment Promo Duration",
    path: "/kim/customizable-segment-promo-duration",
    description:
      "Brands set the per-retailer eligibility window and re-entry cooldown on segment promos. Discount rules adds two day inputs (defaults 7 and 60). Banner copy drops the hardcoded 7 days. Automations recreates the Abandoned cart follow-up email modal; treatment adds promo duration under Discount value when Promotion is Yes.",
    owner: "Chanyee Kim",
    createdAt: "2026-08-18",
    lastUpdated: "2026-09-01",
    project: "Customizable Segment Promo Duration",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/4c38db1deba2d76f738fb5626597bc736f3e2344864b64a15d656c06b8a2ddcf.png",
    creationTool: "cursor",
  },
];
